import React from 'react'

const Chevron = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50.828"
      height="28.427"
      viewBox="0 0 50.828 28.427"
      {...props}>
      <path
        d="M44.067-76.9,64.714-97.726l-9.563-7.6L39.3-90.259,23.449-105.324l-9.563,7.6L35.284-76.9Z"
        transform="translate(-13.886 105.323)"
        fill="currentColor"
      />
    </svg>
  )
}

export default Chevron
